import React from 'react';
import PropTypes from 'prop-types';
import ProfileDetail from 'PointOfSale/modules/serving/component/ProfileDetail';
import InfoMessage from 'PointOfSale/modules/common/component/InfoMessage';

const ServingComponent = ({ currentStudent }) => {
  return (
    <React.Fragment>
      {currentStudent.Id ? (
        <ProfileDetail student={currentStudent} />
      ) : (
        <InfoMessage
          containerClass="auto-serve-empty-queue-msg"
          message="The queue is empty"
        />
      )}
    </React.Fragment>
  );
};

ServingComponent.propTypes = {
  currentStudent: PropTypes.object,
};

export default ServingComponent;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/serving/component/ServingComponent.js